<ng-template #displayTemplateRef
             let-cellData>
  @if (checkHasValue(cellData)) {
    <sc-external-enum-tag [enumType]="columnEnumType"
                          [enumValue]="cellData">
    </sc-external-enum-tag>
  }
</ng-template>